// frontend/src/components/CategoryPage/ArtworkCard.js
import React, { forwardRef } from "react";
import "./ArtworkCard.css";

const ArtworkCard = forwardRef(({ artwork, onClick }, ref) => {
  return (
    <div ref={ref} onClick={onClick} className="artwork-card">
      <div className="artwork-card-image-container">
        <img
          src={artwork.image}
          alt={artwork.title}
          className="artwork-card-image"
        />
      </div>
      <div className="artwork-card-info">
        <h3 className="artwork-card-title">{artwork.title}</h3>
        {/* <p className="artwork-card-date">{artwork.date}</p> */}
      </div>
    </div>
  );
});

ArtworkCard.displayName = "ArtworkCard";

export default ArtworkCard;
